//@ts-check

class IncomeVSBudgetService {
    constructor(
        $sce,
        $http,
        Utility,
        $timeout,
        $rootScope,
        ContentService,
        FinancialsService,
        LocalStorageService,
        InternalLinksService
    ) {
        this.$sce = $sce;
        this.$http = $http;
        this.Utility = Utility;
        this.$timeout = $timeout;
        this.$rootScope = $rootScope;
        this.ContentService = ContentService;
        this.FinancialsService = FinancialsService;
        this.LocalStorageService = LocalStorageService;
        this.InternalLinksService = InternalLinksService;

        this.init();
    }

    async init() {
        await this.InternalLinksService.getLinks('/api/financial/links');
        this.statements = [];
        this.transactions = {};
        this.yearlyTransactions = {};
    }

    async getIncomeVsBudgetStatement(schemeRef, date) {
        let promise, promiseHandler;

        try {
            promise = new Promise((resolve, reject) => {
                promiseHandler = {
                    reject,
                    resolve
                };
            });
            let url = await this.InternalLinksService.getLink('FinancialApiIncomeVsBudgetStatement');
            if (!url) {
                await this.InternalLinksService.getLinks('/api/financial/links');
                url = await this.InternalLinksService.getLink('FinancialApiIncomeVsBudgetStatement');
            }

            url = url.replace('{schemeRef}', schemeRef).trim();
            const headers = this.Utility.headersWithContentType;


            if (!!!headers || (!!headers && (!!!headers.userName || !!!headers.sessionToken))) {
                const error = `Could not load Levy as the 'Username' and/or 'Session Token' is missing`;
                this.$timeout(() => promiseHandler.reject(error));
            }

            const results = await this.$http.post(url, date, { headers: headers });
            const { data} = results;
            this.incomeVsBudgetStatementData = data.Data;
            this.$timeout(() => promiseHandler.resolve());
        } catch (err) {
            this.$timeout(() => promiseHandler.reject(`Error fetching Income Statement Data`, err));
        }

        return promise;
    }

    async getTransactionsForYear({ schemeRef, date, accountCode }) {
        let promise;
        let promiseHandler = {};

        try {
            promise = new Promise((resolve, reject) => {
                promiseHandler = {
                    reject,
                    resolve
                };
            });

            let url = await this.InternalLinksService.getLink('FinancialApiTransactionsForYear');
            if (!url) {
                await this.InternalLinksService.getLinks('/api/financial/links');
                url = await this.InternalLinksService.getLink('FinancialApiInterestTransactions');
            }

            url = url.replace('{schemeRef}', schemeRef).trim();
            url = `${url}?accountCode=${accountCode}`;
            date = this.FinancialsService.getMapFirstDay(date);

            const headers = this.Utility.headersWithContentType;
            const results = await this.$http.post(url, date, { headers });
            const { data } = results;

            if (`${accountCode}` in this.transactions) {
                delete this.transactions[accountCode];
            }

            this.transactions = {
                ...this.transactions,
                [accountCode]: this._mapYearlyTransactions(data)
            };

            this.$timeout(() => promiseHandler.resolve());
        } catch (err) {
            this.$timeout(() => promiseHandler.reject(err));
        }

        return promise;
    }

    _mapYearlyTransactions(original) {
        let transactions = [];

        original.map((trans) => {
            transactions = [...transactions, ...trans.Transactions];
        });

        return transactions;
    }

    async getTransactions(schemeRef, date, accountCode, isInterest) {
        let promise;
        let promiseHandler = {};

        try {
            promise = new Promise((resolve, reject) => {
                promiseHandler = {
                    reject,
                    resolve
                };
            });

            let url = await this.InternalLinksService.getLink('FinancialApiTransactions');
            if (isInterest) {
                url = await this.InternalLinksService.getLink('FinancialApiInterestTransactions');
            }

            if (!url) {
                await this.InternalLinksService.getLinks('/api/financial/links');
                if (isInterest) {
                    url = await this.InternalLinksService.getLink('FinancialApiInterestTransactions');
                } else {
                    url = await this.InternalLinksService.getLink('FinancialApiTransactions');
                }
            }

            url = url.replace('{schemeRef}', schemeRef).trim();
            url = `${url}?accountCode=${accountCode}`;
            date = this.FinancialsService.getMapFirstDay(date);

            const headers = this.Utility.headersWithContentType;
            const results = await this.$http.post(url, date, { headers });
            const { data } = results;

            if (`${accountCode}` in this.transactions) {
                delete this.transactions[accountCode];
            }

            this.transactions[accountCode] = data;

            this.$timeout(() => promiseHandler.resolve());
        } catch (err) {
            this.$timeout(() => promiseHandler.reject(err));
        }

        return promise;
    }
}

export default /* @ngInject */ (
    $sce,
    $http,
    Utility,
    $timeout,
    $rootScope,
    ContentService,
    FinancialsService,
    LocalStorageService,
    InternalLinksService
) =>
    new IncomeVSBudgetService(
        $sce,
        $http,
        Utility,
        $timeout,
        $rootScope,
        ContentService,
        FinancialsService,
        LocalStorageService,
        InternalLinksService
    );
